import { lsPut, safeAwait } from 'utils/request'

export const setPhotoViewed = (photoId) => {
  return safeAwait(lsPut(`/photos/${photoId}/views`))
}
